import React from "react";
import {CircularProgress, TableCell, TableRow} from "@mui/material";

export const TableLoader = ({color, styles = {}}) => {
    return (
        <TableRow className="table-loader-wrapper"
                  style={{...styles, height: styles?.height ? `calc(${styles?.height} - 79px)` : ''}}>
            <TableCell>
                <CircularProgress
                    style={{
                        width: "100px",
                        height: "100px",
                        color: color ? color : "#88C3E1",
                    }}
                />
            </TableCell>
        </TableRow>
    );
};
